document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.wp-block-change-maker-blocks-image-carousel');

  carousels.forEach((carousel) => {
    const showFilmstrip = carousel.dataset.showFilmstrip === '1';
    const autoplaySpeed = carousel.dataset.autoplaySpeed;
    let thumbsSwiper;

    if (showFilmstrip) {
      const thumbsEl = carousel.querySelector('.filmstrip-carousel');
      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
          // spaceBetween: 10,
          slidesPerView: "auto",
          freeMode: true,
          watchSlidesProgress: true,
        });
      }
    }

    const mainEl = carousel.querySelector('.main-carousel');
    if (mainEl) {
      const options = {
        // spaceBetween: 10,
        effect: "fade",
        navigation: {
          nextEl: carousel.querySelector('.nav-next'),
          prevEl: carousel.querySelector('.nav-prev'),
        },
      };
      if (autoplaySpeed > 0) {
        options.autoplay = {
          delay: parseInt(autoplaySpeed, 0) * 1000,
          disableOnInteraction: true,
        };
      }

      if (thumbsSwiper) {
        options.thumbs = { swiper: thumbsSwiper };
      }

      new Swiper(mainEl, options);
    }
  });
});

